import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import {
  REGISTRATION_CONFIG,
  RegistrationConfig,
  SerializationCodeResponse,
} from '@us-registration/util-models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class SerializationService {
  constructor(
    @Inject(REGISTRATION_CONFIG)
    private readonly registrationConfig: RegistrationConfig,
    private readonly httpClient: HttpClient
  ) {}

  readonly client: string = 'WHIRL';

  submitRegistrationCode(
    registrationCode: string | null
  ): Observable<SerializationCodeResponse> {
    return this.httpClient
      .get<SerializationCodeResponse[]>(
        `${this.registrationConfig.applianceLookupUrlBase}/v1/model-serialization-v2-internal?client=${this.client}&registrationCode=${registrationCode}`
      )
      .pipe(map((response: SerializationCodeResponse[]) => response[0]));
  }

  submitModelAndSerialNumber(
    modelNumber: string | undefined,
    serialNumber: string | undefined
  ): Observable<SerializationCodeResponse> {
    return this.httpClient
      .get<SerializationCodeResponse[]>(
        `${this.registrationConfig.applianceLookupUrlBase}/v1/model-serialization-v2-internal?model=${modelNumber}&serial=${serialNumber}`
      )
      .pipe(map((response: SerializationCodeResponse[]) => response[0]));
  }
}
